import Backbone from 'backbone'

import tpl from './template/goodsCounter.mustache'
import { $number } from '../../utils'

import { openPayPopup } from '../../manager/view.handler'
import { BOUNS_REWARD } from '../../config'

export var GoodsCounterView = Backbone.View.extend({
  tagName: 'div',
  className: 'poker-mall-decoration__bill',
  template: tpl,
  events: {
    'click .poker-mall-btn__submit': openPayPopup,
  },

  initialize: function () {
    this.collection.off().on('change', this.render, this)
  },
  render: function () {
    var totalSelectedGoods = this.collection.getSelectedGoods()
    var bounsPrice = $('.poker-mall-decoration__head').data('bouns-price')
    var bounsReward = null

    if (bounsPrice && totalSelectedGoods.goodsCount > 0) {
      bounsReward = {
        rewrad: $number(
          BOUNS_REWARD[bounsPrice].rewrad * totalSelectedGoods.goodsCount
        ).text({ tag: true }),
        bouns: $number(
          BOUNS_REWARD[bounsPrice].bouns * totalSelectedGoods.goodsCount
        ).text({ tag: true }),
      }
    }

    var rendered = this.template.render({
      goodsCount: totalSelectedGoods.goodsCount,
      gameMoney: $number(totalSelectedGoods.gameMoney).text({ tag: true }),
      goodsPrice: $number(totalSelectedGoods.goodsPrice).comma(),
      bounsReward: bounsReward,
    })
    this.$el.empty().append(rendered)
    return this
  },
})
